import { React, useState, useEffect } from "react";
import "./index.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import image from "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from "./img/back.png";
import remove from "./img/remove.png";
import sentmail from "./img/save-mail.png";
import loadergif from "./img/Spin_loader.gif";
import edit from "./img/edit.jpg";
import downloadimg from "./img/dtn-icon.jpg";
import Select from "react-dropdown-select";
import fileDownload from "js-file-download";
// import PDFViewer from 'pdf-viewer-reactjs'
import { Viewer } from "@react-pdf-viewer/core";
import AllPagesPDFViewer from "./pdf/all-pages";
import samplePDF from "./img/adhar.pdf";
import { Document, Page } from "react-pdf";
// import '@react-pdf-viewer/core/lib/styles/index.css';
import uploadimg from "./img/upload_img.png";
import downloadimgbk from "./img/dtn-icon-rmbk.png";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import {
  VENDOR_MASTER_INSERT,
  GET_SAVEDVENDOR,
  VENDOR_MASTER_INACTIVE,
  GET_VENDORLIST,
  GET_SWITCHCODE,
  GET_WORKLOCATION,
  GET_DEPARTMENT,
  GET_RMNAME,
  GET_SWITCHCODEDATA,
  GET_SWITCHEMPDATA,
  GETFILES,
  GETFILESPAN,
  GETFILESNDA,
  GETFILESOFFER,
  POSTDESPFILES,
  SENTMAILAGAIN,
  VENDOR_MASTER_INSERT_RENEW,
  VENDOR_MASTER_VENDOR,
  VENDORNRDFILES,
  GSTFILES,
  CERTICORPFILES,
  VENDORAGREEFILES,
  VENDORPANFILES,
  POSTPARTFILES,
  PROFESSTAX,
  LOCALTRADELICENSES,
  COMMSTAXREG,
  ESIREGFILES,
  CONTRACTLABREG,
  DEED,
  PARTNERSHIPREG,
  AMENDEDFILES,
  LLPAGREEFILES,
  COPYOFPOAFILES,
  MOAFILES,
  ASSOCIATIONFILES,
  COMMENCEFILES,
  CONTRACTPROPOSALFILES,
  CALLCONTRACTAPI,
  GET_VENDORUSERDATA,
  DOWNLOAD_VENDORDATA,
  GET_SEPERATIONDATA,
  GET_SEPERATIONDATATOTAL
} from "../../Pages/AppConstant";

function Landing() {
  const [switch_code, setSwitch_code] = useState("");
  const [employee_code, setEmployee_code] = useState("");
  const [employee_name, setEmployee_name] = useState("");
  const [doj, setDoj] = useState("");
  const [location, setLocation] = useState("");
  const [department, setDepartment] = useState("");
  const [sub_department, setSub_department] = useState("");
  const [reporting_manager, setReporting_manager] = useState("");
  const [manager_id, setManager_id] = useState("");
  const [vendor_code, setVendor_code] = useState("");
  const [contractor_name, setContractor_name] = useState("");
  const [emailid, setEmailid] = useState("");
  const [isfirsttab, setIsfirsttab] = useState(true);
  const [issecondtab, setIssecondtab] = useState(false);
  const [vendorlist, setVendorlist] = useState([]);
  const [vendormasterlist, setVendormasterlist] = useState([]);
  const [searchdata, setSearchdata] = useState([]);
  const [savedvendorraw, setsavedvendorraw] = useState([]);
  const [ismodelopen, setIsmodelopen] = useState(false);
  const [selecteduserdata, setSelecteduserdata] = useState("");
  const [vendorlistdata, setVendorlistdata] = useState([]);
  const [locationlistdata, setLocationlistdata] = useState([]);
  const [switchcode, setSwitchcode] = useState("");
  const [departmentlistdata, setDepartmentlistdata] = useState([]);
  const [subdepartmentlistdata, setSubdepartmentlistdata] = useState([]);
  const [rawdatadept, setRawdatadept] = useState([]);
  const [isselected, setIsselected] = useState(false);
  const [rmlistdata, setRmlistdata] = useState([]);
  const [rmempid, setRmempid] = useState("");
  const [duration, setDuration] = useState("");
  const [billingrate, setBillingrate] = useState("");
  const [jobdiscription, setJobdiscription] = useState("");
  const [serial_code, setSerial_code] = useState("");
  const [costcenter, setCostcenter] = useState("");
  const [transportreq, setTransportreq] = useState("");
  const [couponreq, setCouponreq] = useState("");
  const [systemreq, setSystemreq] = useState("");
  const [assetreq, setAssetreq] = useState("");
  const [sapreq, setSapreq] = useState("");
  const [sapid, setSapid] = useState("");
  const [remarks, setRemarks] = useState("");
  const [isedited, setIsedited] = useState(false);
  const [employee_sec_name, setEmployee_sec_name] = useState("");
  const [gender, setGender] = useState("");
  const [isthirdtab, setIsthirdtab] = useState(false);
  const [typedata, setTypedata] = useState("");
  const [switchcodelist, setSwitchcodelist] = useState([]);
  const [isselecttype, setIsselecttype] = useState(false);
  const [renewcode, setRenewcode] = useState("");
  const [isselectedcode, setIsselectedcode] = useState(false);
  const [isselectrenew, setIsselectrenew] = useState(true);
  const [empdata, setEmpdata] = useState([]);
  const [getduration, setGetduration] = useState("");
  const [viewpdfdcsaadnar, setViewpdfdcsaadnar] = useState("");
  const [viewpdfdcsnda, setViewpdfdcsnda] = useState("");
  const [viewpdfdcsoffer, setViewpdfdcsoffer] = useState("");
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [openpdfadhara, setOpenpdfadhara] = useState(false);
  const [openpdfnda, setOpenpdfnda] = useState(false);
  const [openpdfoffer, setOpenpdfoffer] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [dot, setDot] = useState("");
  const [mindateset, setMindateset] = useState("");
  const [despfile, setDespfile] = useState("");
  const [companyempid, setCompanyempid] = useState("");
  const [ismodelmailopen, setIsmodelmailopen] = useState(false);
  const [selectedmailid, setSelectedmailid] = useState("");
  const [isverified, setIsverified] = useState("");
  const [recommended, setRecommended] = useState("");
  const [comments, setComments] = useState("");
  const [businesstype, setBusinesstype] = useState("");
  const [agreementid, setAgreementid] = useState("");
  const [vendorname, setVendorname] = useState("");
  const [businesdesp, setBusinesdesp] = useState("");
  const [natureofeng, setNatureofeng] = useState("");
  const [csd, setCsd] = useState("");
  const [ced, setCed] = useState("");
  const [businesslicense, setBusinesslicense] = useState("");
  const [brd, setBrd] = useState("");
  const [vnemailid, setVnemailid] = useState("");
  const [primarycontactname, setPrimarycontactname] = useState("");
  const [companyaddress, setCompanyaddress] = useState("");
  const [emailid_primary, setEmailid_primary] = useState("");
  const [mobileno_primary, setMobileno_primary] = useState("");
  const [alt_contact_name, setAlt_contact_name] = useState("");
  const [alt_email_id, setAlt_email_id] = useState("");
  const [partnerdeed, setPartnerdeed] = useState("");
  const [vendornda, setVendornda] = useState("");
  const [gstfile, setGstfile] = useState("");
  const [professtaxfile, setProfesstaxfile] = useState("");
  const [localtradelicense, setLocaltradelicense] = useState("");
  const [commstax, setCommstax] = useState("");
  const [esireg, setEsireg] = useState("");
  const [contlabreg, setContlabreg] = useState("");
  const [deed, setDeed] = useState("");
  const [amended, setAmended] = useState("");
  const [llpagree, setLlpagree] = useState("");
  const [copyofpoa, setCopyofpoa] = useState("");
  const [contractproposal, setContractproposal] = useState("");
  const [certincorp, setCertincorp] = useState("");
  const [partnership, setPartnership] = useState("");
  const [vendoragree, setVendoragree] = useState("");
  const [panfile, setPanfile] = useState("");
  const [vendorcodedata, setVendorcodedata] = useState("");
  const [vendorcontractornamedata, setVendorcontractornamedata] = useState("");
  const [alt_contact_phone, setAlt_contact_phone] = useState("");
  const [isverfiednew, setIsverfiednew] = useState("");
  const [operatingaddress, setOperatingaddress] = useState("");
  const [moa, setMoa] = useState("");
  const [association, setAssociation] = useState("");
  const [commenceofbusiness, setCommenceofbusiness] = useState("");
  const [individualtype, setIndividualtype] = useState(false);
  const [parnershiptype, setParnershiptype] = useState(false);
  const [labellptype, setLlptype] = useState(false);
  const [privateltype, setPrivateltype] = useState(false);
  const [isfourthtab, setIsfourthtab] = useState(false);
  const [selectedvendordata, setSelectedvendordata] = useState("");
  const [opensuccess, setOpensuccess] = useState(false);
  const [successmessage, setSuccessmessage] = useState("");
  const [newfileurl, setNewfileurl] = useState("");
  const [createuri, setCreateuri] = useState("");
  const [isfifth,setIsfifth]= useState(false);
  const [seperationlist,setSeperationlist]= useState([]);
  const [seperationlistall,setSeperationlistall]= useState([]);  
  const [vendorcodesapedata,setVendorcodesapedata]= useState("");
  const [selectedseparationcode,setSelectedseparationcode]= useState("");
  const [issixth,setIssixth]= useState(false);

  useEffect(() => {
    getvendordata();
    calltosetmindate();
  }, []);

  const callvendoruserlist = (e) => {
    // getvendordata()
    let vendors = localStorage.getItem("vendorlogin");
    setSelectedvendordata(vendors);
    if (vendors == "isactive") {
      setIsselecttype(true);
      axios({
        method: "get",
        url: GET_VENDORUSERDATA,
        withCredentials: false,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Access-Control-Allow-Origin": "*",
        },
        params: { primary_name: localStorage.getItem("vendordata") },
      })
        .then((response) => {
          console.log(response.data.data);
          setContractor_name(response.data.data[0].vendorname);
          handleChangevendor(response.data.data[0].vendorname, e);
          setVendorcodesapedata(response.data.data[0].vendorcode)

          setIsselectrenew(true);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const calltosetmindate = () => {
    let month;
    let day;
    if (new Date().getMonth() + 1 < 10) {
      month = "0" + (new Date().getMonth() + 1);
    } else {
      month = new Date().getMonth() + 1;
    }
    if (new Date().getDate() < 10) {
      day = "0" + new Date().getDate();
    } else {
      day = new Date().getDate();
    }
    let date = new Date().getFullYear() + "-" + month + "-" + day;
    setMindateset(date);
  };

  const redirectTodashboard = () => {
    window.location.href = "/landingPage";
  };
  const redirectToLogin = () => {
    localStorage.setItem('vendordata',"")
    localStorage.setItem('vendorlogin',"")
    localStorage.setItem('sessions', "");
    window.location.href = "/login";
  };

  const handleReset = () => {
    setSwitch_code("");
    setEmployee_code("");
    setEmployee_name("");
    setDoj("");
    setDot("");
    setLocation("");
    setDepartment("");
    setSub_department("");
    setReporting_manager("");
    setManager_id("");
    setVendor_code("");
    setContractor_name("");
  };
  const handleSubmit_vender = () => {
    if (
      !agreementid ||
      !vendorname ||
      !businesstype ||
      !operatingaddress ||
      !natureofeng ||
      !businesslicense ||
      !csd ||
      !ced ||
      !brd ||
      !vnemailid ||
      !companyaddress ||
      !businesdesp ||
      !primarycontactname ||
      !mobileno_primary ||
      !emailid_primary ||
      !alt_contact_name ||
      !alt_email_id ||
      !vendorcodedata ||
      !alt_contact_phone ||
      !panfile ||
      !vendoragree ||
      !gstfile ||
      !esireg ||
      !contlabreg ||
      !vendornda
    ) {
      alert("Please fill all the fields");
    } else {
      if (
        businesstype === "Individual" ||
        businesstype === "Sole Proprietorship"
      ) {
        callindividualfn();
      } else if (businesstype === "Partnership") {
        callpartnershipfn();
      } else if (businesstype === "LLP") {
        callllpfn();
      } else if (
        businesstype === "Private Limited" ||
        businesstype === "Public Limited"
      ) {
        callprivatefn();
      }

      // insertdata_vendor();
    }
  };
  const callindividualfn = () => {
    if (!localtradelicense) {
      alert("Please fill all the fields or upload respective files");
    } else {
      insertdata_vendor();
      axios({
        method: "post",
        url: LOCALTRADELICENSES,
        headers: { "Content-Type": "multipart/form-data" },
        data: localtradelicense,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const callpartnershipfn = () => {
    if (!partnership || !deed || !commstax) {
      alert("Please fill all the fields or upload respective files");
    } else {
      insertdata_vendor();
      axios({
        method: "post",
        url: PARTNERSHIPREG,
        headers: { "Content-Type": "multipart/form-data" },
        data: partnership,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: DEED,
        headers: { "Content-Type": "multipart/form-data" },
        data: deed,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: COMMSTAXREG,
        headers: { "Content-Type": "multipart/form-data" },
        data: commstax,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const callllpfn = () => {
    if (!llpagree || !certincorp ) {
      alert("Please fill all the fields or upload respective files");
    } else {
      insertdata_vendor();
      axios({
        method: "post",
        url: LLPAGREEFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: llpagree,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: CERTICORPFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: certincorp,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: COPYOFPOAFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: copyofpoa,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const callprivatefn = () => {
    if (
      !certincorp ||
      !moa ||
      !association ||
     
      !commenceofbusiness
    ) {
      alert("Please fill all the fields or upload respective files");
    } else {
      insertdata_vendor();
      axios({
        method: "post",
        url: CERTICORPFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: certincorp,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: MOAFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: moa,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: ASSOCIATIONFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: association,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      axios({
        method: "post",
        url: COMMENCEFILES,
        headers: { "Content-Type": "multipart/form-data" },
        data: commenceofbusiness,
      })
        .then((response) => {
          // alert(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isedited) {
      if (
        !switchcode ||
        !employee_name ||
        !employee_sec_name ||
        !doj ||
        !dot ||
        !location ||
        !department ||
        !sub_department ||
        !vendor_code ||
        !contractor_name ||
        !emailid ||
        !duration ||
        !jobdiscription ||
        !employee_sec_name ||
        !gender ||
        !companyempid ||
        !reporting_manager ||
        !rmempid ||
        !costcenter ||
        !billingrate ||
        !transportreq ||
        !systemreq ||
        !couponreq ||
        !remarks
      ) {
        alert("Please fill all the fields");
      } else {
        insertdata_update();
      }
    } else if (typedata === "Renewal") {
      if (
        !switchcode ||
        !employee_name ||
        !employee_sec_name ||
        !doj ||
        !dot ||
        !location ||
        !department ||
        !sub_department ||
        !contractor_name ||
        !emailid ||
        !duration ||
        !jobdiscription ||
        !employee_sec_name ||
        !gender ||
        !companyempid
      ) {
        alert("Please fill all the fields");
      } else {
        insertdata_renew();
      }
    } else {
      if (
        !switchcode ||
        !employee_name ||
        !employee_sec_name ||
        !doj ||
        !dot ||
        !location ||
        !department ||
        !sub_department ||
        !vendor_code ||
        !contractor_name ||
        !emailid ||
        !duration ||
        !jobdiscription ||
        !employee_sec_name ||
        !gender ||
        !companyempid
      ) {
        alert("Please fill all the fields");
      } else {
        insertdata();
      }
    }
  };
  const searchfunction = (value) => {
    setSearchdata(value);
    if (value !== "") {
      let e = value.toLowerCase();
      let newarray = savedvendorraw.filter(function (val) {
        if (
          val.switch_code.toLowerCase().includes(e) ||
          val.employee_code.toLowerCase().includes(e) ||
          val.employee_name.toLowerCase().includes(e) ||
          val.location.toLowerCase().includes(e) ||
          val.department.toLowerCase().includes(e) ||
          val.sub_department.toLowerCase().includes(e) ||
          val.reporting_manager.toLowerCase().includes(e) ||
          val.manager_id.toLowerCase().includes(e)
        ) {
          var newobjs = {
            id: val.id,
            switch_code: val.switch_code,
            employee_name: val.employee_name,
          };
          return newobjs;
        }
      });
      setVendorlist(newarray);
    } else {
      setVendorlist(savedvendorraw);
    }
  };
  const searchfunctionvendor = (value) => {
    setSearchdata(value);
    if (value !== "") {
      let e = value.toLowerCase();
      let newarray = savedvendorraw.filter(function (val) {
        if (
          val.switch_code.toLowerCase().includes(e) ||
          val.employee_code.toLowerCase().includes(e) ||
          val.employee_name.toLowerCase().includes(e) ||
          val.location.toLowerCase().includes(e) ||
          val.department.toLowerCase().includes(e) ||
          val.sub_department.toLowerCase().includes(e) ||
          val.reporting_manager.toLowerCase().includes(e) ||
          val.manager_id.toLowerCase().includes(e) ||
          val.vendor_code.toLowerCase().includes(e) ||
          val.contractor_name.toLowerCase().includes(e)
        ) {
          var newobjs = {
            id: val.id,
            switch_code: val.switch_code,
            employee_name: val.employee_name,
          };
          return newobjs;
        }
      });
      setVendorlist(newarray);
    } else {
      setVendorlist(savedvendorraw);
    }
  };

  const insertdata_vendor = () => {
    axios
      .post(VENDOR_MASTER_VENDOR, {
        agreementid,
        vendorname,
        businesstype,
        operatingaddress,
        natureofeng,
        csd,
        ced,
        businesslicense,
        brd,
        vnemailid,
        companyaddress,
        businesdesp,
        primarycontactname,
        emailid_primary,
        alt_contact_name,
        alt_email_id,
        vendorcodedata,
        alt_contact_phone,
        mobileno_primary,
      })
      .then(function (response) {
        //   console.log("SuccessFully created");
        //   alert(response.data);
        setOpensuccess(true);
        setSuccessmessage("Vendor successfully onboarded");
        setIsthirdtab(true);
      })
      .catch(function (error) {
        console.log(error);
      });

    axios({
      method: "post",
      url: AMENDEDFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: amended,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: CONTRACTPROPOSALFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: contractproposal,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: POSTPARTFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: partnerdeed,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
    axios({
      method: "post",
      url: VENDORPANFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: panfile,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
    axios({
      method: "post",
      url: VENDORAGREEFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: vendoragree,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: GSTFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: gstfile,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: PROFESSTAX,
      headers: { "Content-Type": "multipart/form-data" },
      data: professtaxfile,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: CONTRACTLABREG,
      headers: { "Content-Type": "multipart/form-data" },
      data: contlabreg,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: ESIREGFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: esireg,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "post",
      url: VENDORNRDFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: vendornda,
    })
      .then((response) => {
        // alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const insertdata_update = () => {
    let switch_code = switchcode;
    let employee_code = companyempid;
    let verified = isverified;
    let status;
    if (verified === "Yes") {
      status = "Completed";
    } else {
      status = "Awating User response";
    }

    let hremailid;
    if (location == "Corporate") {
      hremailid = "lead_malathi.s@switchmobilityev.com";
    } else if (location == "VVC") {
      hremailid = "thomas.arun@switchmobilityev.com";
    } else if (location == "Ennore") {
      hremailid = "thiyagu.chinnusamy@switchmobilityev.com";
    } else {
      hremailid = "Bindu.Ramachandran@switchmobilityev.com";
    }

    axios
      .post(VENDOR_MASTER_INSERT, {
        switch_code,
        employee_name,
        reporting_manager,
        rmempid,
        costcenter,
        billingrate,
        transportreq,
        systemreq,
        couponreq,
        remarks,
        verified,
        assetreq,
        sapreq,
        status,
        sapid,
        emailid,
        jobdiscription,
        hremailid,
        doj,
        employee_name,
        employee_sec_name,
        emailid,
        location,
        department,
        sub_department,
        duration,
        dot,
        gender
      })
      .then(function (response) {
        console.log("SuccessFully created");
        //   alert(response.data);
        setOpensuccess(true);
        setSuccessmessage("Third party user details updated");
        handleReset();
      })
      .catch(function (error) {
        console.log(error);
      });
    axios({
      method: "post",
      url: POSTDESPFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: despfile,
    })
      .then((response) => {
        alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const insertdata_renew = () => {
    let switch_code = switchcode;
    let employee_code = companyempid;
    let status = "Renews";

    axios
      .post(VENDOR_MASTER_INSERT_RENEW, {
        switch_code,
        employee_name,
        employee_sec_name,
        gender,
        doj,
        dot,
        location,
        department,
        sub_department,
        emailid,
        duration,
        jobdiscription,
        vendor_code,
        contractor_name,
        serial_code,
        gender,
        employee_code,
        status,
      })
      .then(function (response) {
        console.log("SuccessFully created");
        alert(response.data);
        setOpensuccess(true);
        setSuccessmessage(
          "User details submitted successfully. An onboarding email has been sent to the candidate"
        );
        handleReset();
      })
      .catch(function (error) {
        console.log(error);
      });
    axios({
      method: "post",
      url: POSTDESPFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: despfile,
    })
      .then((response) => {
        alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const insertdata = () => {
    let switch_code = switchcode;
    let employee_code = companyempid;
    let verififed = "No";
    let status = "Awating User response";
    let remarks = "Mail Sent";
    let hremailid;
    if (location == "Corporate") {
      hremailid = "Bindu.Ramachandran@switchmobilityev.com";
    } else if (location == "VVC") {
      hremailid = "thomas.arun@switchmobilityev.com";
    } else if (location == "Ennore") {
      hremailid = "thiyagu.chinnusamy@switchmobilityev.com";
    } else {
      hremailid = "Bindu.Ramachandran@switchmobilityev.com";
    }
    axios
      .post(VENDOR_MASTER_INSERT, {
        switch_code,
        employee_name,
        employee_sec_name,
        gender,
        doj,
        dot,
        location,
        department,
        sub_department,
        emailid,
        duration,
        jobdiscription,
        vendor_code,
        contractor_name,
        serial_code,
        gender,
        employee_code,
        verififed,
        status,
        remarks,
        hremailid,
      })

      .then(function (response) {
        console.log("SuccessFully created");
        setOpensuccess(true);
        setSuccessmessage(
          "User details submitted successfully. An onboarding email has been sent to the candidate"
        );
        handleReset();
      })
      .catch(function (error) {
        console.log(error);
      });
    axios({
      method: "post",
      url: POSTDESPFILES,
      headers: { "Content-Type": "multipart/form-data" },
      data: despfile,
    })
      .then((response) => {
        alert(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const callseparationlist=()=>{
    axios({
          method: "get",
          url: GET_SEPERATIONDATA,
          withCredentials: false,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Access-Control-Allow-Origin": "*",
          },
        params: { vendor_code: vendorcodesapedata },
        })
          .then((response) => {
              setSeperationlist(response.data.data)
              // setVendorlist(response.data.data);
          })
          .catch((error) => {
            console.error(error);
          });
  }
  const callseparationlistall=()=>{
    axios({
          method: "get",
          url: GET_SEPERATIONDATATOTAL,
          withCredentials: false,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Access-Control-Allow-Origin": "*",
          }
        })
          .then((response) => {
              setSeperationlistall(response.data.data)
              // setVendorlist(response.data.data);
          })
          .catch((error) => {
            console.error(error);
          });
  }
  
  const enabletab = (e) => {
    if (e === 2) {
      setIsfourthtab(false);
      setIsedited(false);
      setIsfirsttab(false);
      callsaveddata();
      setIssecondtab(true);
      setIsthirdtab(false);
      setIsfifth(false)
       setIssixth(false);
      handleReset();
      setIsselecttype(false);
    } else if (e === 3) {
      setIsfourthtab(false);
      setIsthirdtab(true);
      setIsfirsttab(false);
      setIssecondtab(false);
      setIsfifth(false)
       setIssixth(false);
    } else if (e === 4) {
      setIsfourthtab(true);
      setIsfirsttab(false);
      setIssecondtab(false);
      setIsthirdtab(false);
      setIsfifth(false)
       setIssixth(false);
    } else if(e === 5){
      setIsfourthtab(false);
      setIsfirsttab(false);
      setIssecondtab(false);
      setIsthirdtab(false);
      setIsfifth(true)
       setIssixth(false);
      callseparationlist()
    }else if(e === 6){
      setIsfourthtab(false);
      setIsfirsttab(false);
      setIssecondtab(false);
      setIsthirdtab(false);
      setIsfifth(false);
      setIssixth(true);
      callseparationlistall()
    }
    else {
      setIsfourthtab(false);
      setIsfirsttab(true);
      setIssecondtab(false);
      setIsthirdtab(false);
      setIsfifth(false)
       setIssixth(false);
    }
  };

 const formatDate = (dateString) => { 
  const date = new Date(dateString);  
  return `${String(date.getDate()).padStart(2, "0")}-${String( date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
};
  // const callsavedvendordata=()=>{

  //     axios({
  //         method: "get",
  //         url: GET_VENDORMASTER,
  //         withCredentials: false,
  //         headers: {
  //           "Content-Type": "application/x-www-form-urlencoded",
  //           "Access-Control-Allow-Origin": "*",
  //         },
  //       })
  //         .then((response) => {
  //             setVendormasterlist(response.data.data)
  //             // setVendorlist(response.data.data);
  //         })
  //         .catch((error) => {
  //           console.error(error);
  //         });
  // }
  const callsaveddata = () => {
    axios({
      method: "get",
      url: GET_SAVEDVENDOR,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        setsavedvendorraw(response.data.data);
        setVendorlist(response.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getvendordata = () => {
    axios({
      method: "get",
      url: GET_VENDORLIST,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        setVendorlistdata(response.data.data);
        callvendoruserlist(response.data.data);
      })
      .catch((error) => {
        console.error(error);
      });

    axios({
      method: "get",
      url: GET_WORKLOCATION,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        setLocationlistdata(response.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
    axios({
      method: "get",
      url: GET_DEPARTMENT,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        setRawdatadept(response.data.data);
        const dist = response.data.data.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.department === obj.department)
        );
        setDepartmentlistdata(dist);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const removeuser = (val) => {
    setIsmodelopen(true);
    setSelecteduserdata(val);
    setSwitchcode(val.switch_code);
  };
  const edituser = (e) => {
    calluserdata(e.switch_code);
    setIsedited(true);
    setIsfirsttab(true);
    setIssecondtab(false);
  };
  const confirmremove = (es) => {
    
    axios
      .post(VENDOR_MASTER_INACTIVE, {
        switch_code: selectedseparationcode,
        Comments: comments,
        SW_REC: recommended,
        exit_request:es
      })
      .then(function (response) {
        callsaveddata();
        alert("SuccessFully Removed");
        console.log("SuccessFully updated");
        setIsmodelopen(false);
      })
      .catch(function (error) {
        console.log(error);
        setIsmodelopen(false);
      });
  };
  const callclose = () => {
    setIsmodelopen(false);
    setOpenpdfadhara(false);
    setOpenpdfnda(false);
    setOpenpdfoffer(false);
  };
  const handleChangevendor = (e, k) => {
    // console.log(e.target.value)
    let selectdata = e;
    setContractor_name(selectdata);
    console.log(k);
    for (let i = 0; i < k.length; i++) {
      if (k[i].vendorname === selectdata) {
        // setCodename(vendorlistdata[i].vendorcode)
        getswitchcode(selectdata, k[i].vendorcode);
      }
    }
  };
  const handleChangelocation = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setLocation(selectdata);
  };

  const handleChangebusinesstype = (e) => {
    console.log(e.target.value);
    let selectdata = e.target.value;
    setBusinesstype(selectdata);

    if (
      e.target.value == "Individual" ||
      e.target.value == "Sole Proprietorship"
    ) {
      setIndividualtype(true);
      setParnershiptype(false);
      setLlptype(false);
      setPrivateltype(false);
    } else if (e.target.value == "Partnership") {
      setParnershiptype(true);
      setIndividualtype(false);
      setLlptype(false);
      setPrivateltype(false);
    } else if (e.target.value == "LLP") {
      setLlptype(true);
      setParnershiptype(false);
      setIndividualtype(false);
      setPrivateltype(false);
    } else if (
      e.target.value == "Private Limited" ||
      e.target.value == "Public Limited"
    ) {
      setPrivateltype(true);
      setIndividualtype(false);
      setParnershiptype(false);
      setLlptype(false);
    }
  };

  const handleChangegender = (e) => {
    let selectdata = e.target.value;
    setGender(selectdata);
  };
  const handleChangerecoment = (e) => {
    setRecommended(e.target.value);
  };
  const handleChangetype = (e) => {
    let selectdata = e.target.value;
    setTypedata(selectdata);
    if (selectdata === "New") {
      setIsselecttype(true);
      setIsselectrenew(false);
    } else if (selectdata === "Renewal") {
      setIsselecttype(false);
      setIsselectrenew(true);
    }
  };

  const handleChangeduration = (e) => {
    let newDate;
    if (isedited === false) {
      newDate = new Date();
    } else {
      newDate = new Date(getduration);
      // alert(newDate)
    }
    let selectdata = parseInt(e.target.value);
    // Create a new Date instance to avoid mutating the original date
    newDate.setMonth(newDate.getMonth() + selectdata);
    let year;
    let month;
    let day;

    year = new Date(newDate).getFullYear();
    if (new Date(newDate).getMonth() + 1 <= 9) {
      month = "0" + (new Date(newDate).getMonth() + 1);
    } else {
      month = new Date(newDate).getMonth() + 1;
    }
    if (new Date(newDate).getDate() <= 9) {
      day = "0" + new Date(newDate).getDate();
    } else {
      day = new Date(newDate).getDate();
    }
    let durationdate = year + "-" + month + "-" + day;
    console.log(newDate);
    setDuration(durationdate);
  };
  const handleChangedepartment = (e) => {
    console.log(e);
    let array = [];
    let selecteddata = e;
    for (let i = 0; i < rawdatadept.length; i++) {
      if (rawdatadept[i].department === selecteddata) {
        array.push(rawdatadept[i]);
      }
    }
    setDepartment(selecteddata);
    setSubdepartmentlistdata(array);
  };

  const handleChangesubdepmartment = (e) => {
    console.log(e.target.value);
    setSub_department(e.target.value);
  };

  const getswitchcode = (e, v) => {
    axios({
      method: "get",
      url: GET_SWITCHCODE,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { contractor_name: e },
    })
      .then((response) => {
        // console.log(response.data.data)
        let id;
        if (response.data.data.length === 0) {
          id = "000";
        } else {
          id = response.data.data[0].serial_code;
        }

        let digits = (parseInt(id.replace(/[^0-9]/g, "")) + 1).toString();
        if (digits.length < 4) digits = ("000" + digits).substr(-4);
        id = v + digits;
        console.log(id);
        setSerial_code(digits);
        setVendor_code(v);
        setSwitchcode(id);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const callmanagerfn = (e) => {
    setReporting_manager(e);
    axios({
      method: "get",
      url: GET_RMNAME,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { rmlist: e },
    })
      .then((response) => {
        // console.log(response.data.data)
        setRmlistdata(response.data.data);
        setIsselected(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handlechangerename = (e) => {
    setReporting_manager(e.target.value);
    for (let i = 0; i < rmlistdata.length; i++) {
      if (rmlistdata[i].employee_name === e.target.value)
        setRmempid(rmlistdata[i].employee_id);
    }
    setIsselected(false);
  };

  const transportfn = (e) => {
    setTransportreq(e.target.value);
  };
  const couponfn = (e) => {
    setCouponreq(e.target.value);
  };
  const assettyprfn = (e) => {
    setAssetreq(e.target.value);
  };
  const systemfn = (e) => {
    let data = e.target.value;
    if (data === "No") {
      setAssetreq("NA");
      setSapreq("NA");
    }
    setSystemreq(e.target.value);
  };
  const sapfn = (e) => {
    setSapreq(e.target.value);
  };

  const callrenewfn = (e) => {
    setRenewcode(e);
    axios({
      method: "get",
      url: GET_SWITCHCODEDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { switchcode: e },
    })
      .then((response) => {
        // console.log(response.data.data)
        setSwitchcodelist(response.data.data);
        setIsselectedcode(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handlechangecode = (e) => {
    setRenewcode(e.target.value);
    calluserdata(e.target.value);
  };
  const downloadfiles = (ee) => {
    const hrefee = createuri;
    const link = document.createElement("a");
    link.href = hrefee;
    link.setAttribute("download", employee_name + "_" + ee + "_.pdf"); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
  };
  const calladharcard = () => {
    setIsloading(true);
    axios({
      method: "post",
      url: GETFILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { switchcode: switchcode },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfdcsaadnar(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfdcsaadnar(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfdcsaadnar(dataset);
            setOpenpdfadhara(true);
            setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const calloffercard = () => {
    setIsloading(true);
    axios({
      method: "post",
      url: GETFILESOFFER,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { switchcode: switchcode },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setViewpdfdcsoffer(urlss);
        setCreateuri(urlss);
        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        console.log(response.data);
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfdcsoffer(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfdcsoffer(dataset);
            setOpenpdfoffer(true);
            setIsloading(false);
          };
        }
      })

      .catch((error) => {
        console.error(error);
      });
  };
  const callndacard = () => {
    // axios({
    //     method: 'post',
    //     url: GETFILESPAN,
    //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     data : { switchcode: switchcode },
    //     responseType: 'blob',
    //   })
    //     .then((response) => {
    //         const urlss = URL.createObjectURL(response.data);
    //         console.log(urlss)
    //         setViewpdfdcs(urlss)
    //         // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
    //         console.log(response.data)
    //         var reader = new FileReader();
    //         reader.readAsDataURL(response.data);
    //         reader.onloadend = function() {
    //         var base64data = reader.result;
    //         console.log(base64data);
    //         setViewpdfdcs(base64data)
    //         let data_split = base64data.split(",");
    //        let dataset =  "data:application/pdf;base64," + data_split[1] +"#toolbar=0"
    //         setViewpdfdcs(dataset)
    //         setOpenpdf(true)
    //         }

    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    setIsloading(true);
    axios({
      method: "post",
      url: GETFILESNDA,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { switchcode: switchcode },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setViewpdfdcsnda(urlss);
        setCreateuri(urlss);
        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        console.log(response.data);
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfdcsnda(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfdcsnda(dataset);
            setOpenpdfnda(true);
            setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const calluserdata = (e) => {
    axios({
      method: "get",
      url: GET_SWITCHEMPDATA,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
      params: { switchcode: e },
    })
      .then((response) => {
        // console.log(response.data.data)
        let empdata = response.data.data[0];
        setCompanyempid(empdata.employee_code);
        setEmpdata(empdata);
        setIsselecttype(true);
        setContractor_name(empdata.contractor_name);
        setSwitchcode(empdata.switch_code);
        setDoj(empdata.doj);
        setDot(empdata.dot);
        setDuration(empdata.duration);
        setEmployee_name(empdata.employee_name);
        setEmployee_sec_name(empdata.employee_sec_name);
        setGender(empdata.gender);
        setEmailid(empdata.emailid);
        setLocation(empdata.location);
        setDepartment(empdata.department);
        handleChangedepartment(empdata.department);
        setSub_department(empdata.sub_department);
        setJobdiscription(empdata.jobdiscription);
        setIsselectedcode(false);
        setGetduration(empdata.duration);
        setVendor_code(empdata.vendor_code);
        setReporting_manager(empdata.reporting_manager);
        setRmempid(empdata.manager_id);
        if (empdata.verified == "Yes") {
          setIsverfiednew("verified");
        } else {
          setIsverfiednew("notverified");
        }
        setCostcenter(empdata.costcenter);
        setBillingrate(empdata.billingrate);
        setTransportreq(empdata.transportreq);
        setCouponreq(empdata.couponreq);
        setAssetreq(empdata.assetreq);
        setSystemreq(empdata.systemreq);
        setSapreq(empdata.sapreq);
        setSapid(empdata.sapid);
        // setRemarks(empdata.remarks)
        // setCostcenter(empdata.gender)
        // setBillingrate(empdata.gender)
        // setTransportreq(empdata.gender)
        // setCouponreq(empdata.gender)
        // setassetreq(empdata.gender)
        // setIsselectedcode(true)
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const checkedval = (e) => {
    if (e.target.checked) {
      let text = "Press a button!\nEither OK or Cancel. To confirm the verify";
      if (window.confirm(text) == true) {
        setIsverified("Yes");
        text = "You pressed OK!";
      } else {
        document.getElementById("checkboxs").checked = false;
        setIsverified("No");
        text = "You canceled!";
      }
    } else {
      setIsverified("No");
    }
  };
  const checkedvalnew = (e) => {
    if (e == "verified") {
      setIsverfiednew("verified");
      let text =
        "Press a button!\nEither OK or Cancel. To confirm the verified";
      if (window.confirm(text) == true) {
        setIsverified("Yes");
        text = "You pressed OK!";
      } else {
        setIsverfiednew("notverified");

        setIsverified("No");
        text = "You canceled!";
      }
    } else {
      setIsverfiednew("notverified");
      setIsverified("No");
    }
  };
  const addjobdec = () => {};
  const filechangedesfn = (file, d) => {
    console.log(file);
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "DESP_docs");
        formData.append("ID", switchcode);
        formData.append("file", file);
        console.log(formData);
        setDespfile(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const mailsent = (val) => {
    setSelectedmailid(val.emailid);
    setSwitchcode(val.switch_code);
    setIsmodelmailopen(true);
  };
  const closemailbox = () => {
    setIsmodelmailopen(false);
  };
  const mailsentfn = () => {
    axios({
      method: "post",
      url: SENTMAILAGAIN,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { switchcode: switchcode, sentmailid: selectedmailid },
    })
      .then((response) => {
        console.log(response.data);
        closemailbox();
        alert("Mailsent Successfully");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const filechangefn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Certificate_of_Incorporation");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setCertincorp(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };

  const fccertificommbusiness = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Certificate of Commencement of Business");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setCommenceofbusiness(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangeassociation = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Articles_of_Association");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setAssociation(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangemoa = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Memorandum");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setMoa(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangepoa = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "copy_of_POA");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setCopyofpoa(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangellp = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "LLP_Agreement");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setLlpagree(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangeamended = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Amended_Partnership_Deed");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setAmended(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangeregisfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Partnership Registration Deed ");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setPartnerdeed(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };

  const filechangendproposalfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Contract_Proposal_form");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setContractproposal(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangendasignedfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Vendor(NDA) ");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setVendornda(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangegstfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "GST ");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setGstfile(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };

  const filechangeproftaxfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "professTax ");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setProfesstaxfile(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };

  const filechangedeed = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Partnership_deed");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setDeed(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };

  const filechangepartnership = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "PartnerShipRegistration");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setPartnership(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangecontlabreg = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Contract_lab_reg");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setContlabreg(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangeesifn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "esi");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setEsireg(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangecommstaxregfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "commtaxreg");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setCommstax(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangelocallicensefn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Localtradelicense ");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setLocaltradelicense(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangepanfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "PAN");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setPanfile(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const filechangevendoraggfn = (file, d) => {
    // setRawdatafile(file)
    if (file.type === "application/pdf") {
      if (file.size <= 5000000) {
        const formData = new FormData();
        formData.append("type", "Vendor_agreement");
        formData.append("ID", vendorname);
        formData.append("file", file);
        console.log(formData);
        setVendoragree(formData);
      } else {
        document.getElementById(d).value = "";
        alert("Upload Size not greater than 5 MB");
      }
    } else {
      document.getElementById(d).value = "";
      alert("Please Upload only PDF format");
    }
  };
  const checkmobileno = (e) => {
    if (e.length <= 10) {
      setMobileno_primary(e);
    } else {
      alert("Mobile No. Should not be 10 digit");
    }
  };
  const checkmobileprimary = (e) => {
    if (e.length <= 10) {
      setPrimarycontactname(e);
    } else {
      alert("Mobile No. Should not be 10 digit");
    }
  };
  const checkmobilealt = (e) => {
    if (e.length <= 10) {
      setAlt_contact_phone(e);
    } else {
      alert("Mobile No. Should not be 10 digit");
    }
  };
  const callvendornamefn = (e) => {
    let datas = e.target.value;
    setAgreementid(datas);
    if (datas.length >= 3) {
      callmycontractfn(datas);
    }
  };
  const callmycontractfn = (e) => {
    axios
      .post(CALLCONTRACTAPI, { ContractID: e })
      .then(function (response) {
        console.log("SuccessFully created");
        //   alert(response.data[0]);

        let selecteddata = response.data[1];
        if (selecteddata !== undefined) {
          setVendorname(selecteddata.Vendor_Name);
          let scddate = selecteddata.Effective_Date.split("T");
          let scedate = selecteddata.Expiry_Date.split("T");
          setCsd(scddate[0]);
          // setCsd(selecteddata.Effective_Date)
          setCed(scedate[0]);
          setOperatingaddress(selecteddata.Vendor_Address);
        } else {
          alert("Contract ID is not available");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    // axios({
    //     method: 'post',
    //     url: "http://switchmobilitytest.my-contracts.co.in/api/GetVendorDataInfo",
    //     headers: { 'Access-Control-Allow-Origin' : '*' },
    //     data : { "ContractID":e },

    //   })
    //     .then((response) => {
    //         console.log(response.data)
    //         closemailbox()
    //         alert("Mailsent Successfully")

    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
  };
  const callclosesuccess = () => {
    setOpensuccess(false);
  };

  const generatereport = () => {
    axios({
      method: "get",
      url: DOWNLOAD_VENDORDATA,
      withCredentials: false,
      responseType: "blob",
      // params:{"start" :startdate,"end":enddate},
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        fileDownload(response.data, "Vendormaster" + new Date() + ".xlsx");

        // OR you can save/write file locally.
        // fs.writeFileSync(outputFilename, response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const separatefn = (val)=>{
    setIsmodelopen(true)
    setSelectedseparationcode(val.switch_code)
    
  }
  return (
    <div className="bg_set_ven_cr">
      {isloading ? (
        <div className="loadergif">
          <img src={loadergif} />{" "}
        </div>
      ) : (
        ""
      )}

       {selectedvendordata !== "isactive"
                  ? <div >
        <img
          className="switch-back-ven"
          onClick={redirectTodashboard}
          src={imagebk}
        />
        {/* <img className="switch-img" src={image}/> */}
        <img
          className="logout-img-ven"
          title="Logout"
          onClick={redirectToLogin}
          src={logoutimg}
        />
      </div>
                  : ""}
      <br />
      <br />
      <div></div>
      <div>
        <div>
          {opensuccess === true ? (
            <div id="myModal" className="modal-one-docs">
              <div className="closebar">
                {" "}
                <span
                  className="close-one-success"
                  onClick={() => callclosesuccess()}
                >
                  &times;
                </span>
              </div>
              <div className="model-content-success">
                <p>{successmessage}</p>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="Apps-asset">
            <p className="Headings">Third party / Contractual Employees</p>
            <div className="row tabdesign_vm">
              {selectedvendordata !== "isactive" ? (
                <div
                  className={
                    isthirdtab
                      ? "col-md-2 tabfirst-selected"
                      : "col-md-2 notselected"
                  }
                  onClick={() => enabletab(3)}
                >
                  Vendor Creation
                </div>
              ) : (
                ""
              )}
              {selectedvendordata !== "isactive" ? (
                <div
                  className={
                    isfourthtab
                      ? "col-md-2 tabfirst-selected"
                      : "col-md-2 notselected"
                  }
                  onClick={() => enabletab(4)}
                >
                  Vendor View{" "}
                </div>
              ) : (
                ""
              )}
              <div
                className={
                  isfirsttab
                    ? "col-md-2 tabfirst-selected"
                    : "col-md-2 notselected"
                }
                onClick={() => enabletab(1)}
              >
                {" "}
                {selectedvendordata !== "isactive"
                  ? "User Renewal"
                  : "User Creation"}
              </div>
              {selectedvendordata !== "isactive" ? (
                <div
                  className={
                    issecondtab
                      ? "col-md-2 tabfirst-selected"
                      : "col-md-2 notselected"
                  }
                  onClick={() => enabletab(2)}
                >
                  Employee List{" "}
                </div>
              ) : (
                ""
              )}
              {selectedvendordata !== "isactive" ? '':(
              <div
                  className={
                    issecondtab
                      ? "col-md-2 tabfirst-selected"
                      : "col-md-2 notselected"
                  }
                  onClick={() => enabletab(5)}
                >
                  Separation{" "}
                </div>)}
              {/* <div className="col-md-2 tabfour">View Request</div> */}
               {selectedvendordata !== "isactive" ? (
                <div
                  className={
                    issixth
                      ? "col-md-2 tabfirst-selected"
                      : "col-md-2 notselected"
                  }
                  onClick={() => enabletab(6)}
                >
                  Seperation{" "}
                </div>
              ) : (
                ""
              )}
            </div>
            {ismodelopen ? (
              <div id="myModal" class="modal-one">
                <div class="modal-content-one-delete">
                  <span class="close-one-delete" onClick={() => callclose()}>
                    &times;
                  </span>
                  <h4>Separation User</h4>
                  <div className="row spacing">
                    <div className="col-md-12">
                      {/* <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="switchcode">Switch Code</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="switchcode"
                            id="switchcode"
                            value={switchcode}
                            disabled
                            placeholder="Enter Switch Code"
                            required
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="row spacing">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="gender">
                            Switch Role Recommendation
                          </label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handleChangerecoment(e)}
                            defaultValue=""
                            value={recommended}
                            // onChange={(e) =>callselectrequest(e)}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row spacing">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="employeename">Comments</label>
                        </div>
                        <div className="col-md-6">
                          {/* <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={comments}
                            onChange={(e) =>
                                setComments(e.target.value)
                            }
                            placeholder="Enter Comments"
                            required
                        /> */}
                          <textarea
                            id="faultreport"
                            name="faultreport"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Write your message"
                            rows="2"
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        {" "}
                        <Button
                          className="button-design"
                          onClick={() => {
                            confirmremove("approved");
                          }}
                        >
                          Confirm
                        </Button>
                      </div>
                      <div className="col-md-6">
                        <Button
                          className="button-design"
                          onClick={() => {
                            confirmremove("reject");
                          }}
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            
            {ismodelmailopen ? (
              <div id="myModal" class="modal-one">
                <div class="modal-content-one-delete">
                  <span class="close-one-delete" onClick={() => closemailbox()}>
                    &times;
                  </span>
                  <h4>Resend Mail</h4>
                  <div className="row spacing">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="switchcode">Switch Code</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="switchcode"
                            id="switchcode"
                            value={switchcode}
                            disabled
                            placeholder="Enter Switch Code"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row spacing">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="employeename">
                            Email ID
                            <br />
                            (Personal ID)
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={selectedmailid}
                            onChange={(e) => setSelectedmailid(e.target.value)}
                            placeholder="Enter Email ID"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        {" "}
                        <Button
                          className="button-design"
                          onClick={() => {
                            mailsentfn();
                          }}
                        >
                          Mail Send
                        </Button>
                      </div>
                      <div className="col-md-6">
                        <Button
                          className="button-design"
                          onClick={() => {
                            closemailbox();
                          }}
                        >
                          cancel
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {isfirsttab ? (
              <fieldset>
                <form action="#" method="get">
                  {/* {selectedvendordata!=="isactive"?!isedited?<div className="row spacing">
                    <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-2"><label htmlFor="gender">Type</label></div>
                        <div className="col-md-6"> 
                        <select
                        name="select"
                        id="selected"
                        onChange={e => handleChangetype(e)} 
                        defaultValue=""
                        // value={selectvendores}
                        // onChange={(e) =>callselectrequest(e)}
                    >
                         <option value=""  disabled >
                          Select
                        </option>
                         <option value="New" >New</option> 
                        <option value="Renewal" >Renewal</option>
                                              
                        </select>
                       
                        </div>
                        </div> 
                        </div> 
                    </div> :'':''} */}
                  {/* <div className="col-md-4">                   
                       <div className="row vendor_code">
                       <div className="col-md-5"><label htmlFor="renewemp">
                       Switch Code
                       </label></div>
                       <div className="col-md-7"> 
                       <input
                           type="text"
                           name="renewemp"
                           id="renewemp"
                           value={renewcode}
                           onChange={(e) =>
                               callrenewfn(e.target.value)
                           }
                           placeholder="Enter Switch Code"
                           required
                       /> 
                       {isselectedcode?<select
                       name="select"
                       id="selected"
                       onChange={e => handlechangecode(e)} 
                       defaultValue=""
                       
                   >
                        <option value=""  disabled >
                         Select
                       </option>
                        {switchcodelist.map((e, index) => (
                            <option value={e.switch_code} >{e.switch_code} ({e.employee_name})</option>
                        ))}
                      
                                             
                       </select>:""}  
                       
                         
                           </div>
                       </div>
                       </div>  */}
                  {isselecttype ? (
                    <>
                      <div className="row spacing">
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="switchcode">Vendor</label>
                            </div>
                            <div className="col-md-6">
                              <select
                                name="select"
                                id="selected"
                                onChange={(e) => handleChangevendor(e)}
                                defaultValue=""
                                value={contractor_name}
                                disabled
                                // onChange={(e) =>callselectrequest(e)}
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                {vendorlistdata.map((e, index) => (
                                  <option value={e.vendorname}>
                                    {e.vendorname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="switchcode">Switch Code</label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                name="switchcode"
                                id="switchcode"
                                value={switchcode}
                                disabled
                                placeholder="Enter Switch Code"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="Company empID">
                                {contractor_name} emp ID{" "}
                              </label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                name="companyempid"
                                id="companyempid"
                                value={companyempid}
                                onChange={(e) =>
                                  setCompanyempid(e.target.value)
                                }
                                placeholder="Enter Current Company Employee ID"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row spacing">
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="birthday">DOJ</label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="date"
                                value={doj}
                                onChange={(e) => setDoj(e.target.value)}
                                id="birthday"
                                name="birthday"
                              />
                            </div>
                          </div>{" "}
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="employeename">First Name</label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                name="employeename"
                                id="employeename"
                                value={employee_name}
                                onChange={(e) =>
                                  setEmployee_name(e.target.value)
                                }
                                placeholder="First Name"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="employeesecondname">
                                Second Name
                              </label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                name="employeenamesec"
                                id="employeename"
                                value={employee_sec_name}
                                onChange={(e) =>
                                  setEmployee_sec_name(e.target.value)
                                }
                                placeholder="Second Name"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row spacing">
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="gender">Gender</label>
                            </div>
                            <div className="col-md-6">
                              <select
                                name="select"
                                id="selected"
                                onChange={(e) => handleChangegender(e)}
                                defaultValue=""
                                value={gender}
                                // onChange={(e) =>callselectrequest(e)}
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="employeename">
                                Email ID
                                <br />
                                (Personal ID)
                              </label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                name="employeename"
                                id="employeename"
                                value={emailid}
                                onChange={(e) => setEmailid(e.target.value)}
                                placeholder="Enter Email ID"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="lastname">Work Location</label>
                            </div>
                            <div className="col-md-6">
                              <select
                                name="select"
                                id="selected"
                                onChange={(e) => handleChangelocation(e)}
                                defaultValue=""
                                value={location}
                                // onChange={(e) =>callselectrequest(e)}
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                {locationlistdata.map((e, index) => (
                                  <option value={e.locations}>
                                    {e.locations}
                                  </option>
                                ))}
                              </select>
                              {/* <input
                            type="text"
                            name="worklocation"
                            id="worklocation"
                            value={location}
                            onChange={(e) =>
                                setLocation(e.target.value)
                            }
                            placeholder="Enter Work Location"
                            required
                        /> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row spacing">
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="department">Department</label>
                            </div>
                            <div className="col-md-6">
                              <select
                                name="select"
                                id="selected"
                                onChange={(e) =>
                                  handleChangedepartment(e.target.value)
                                }
                                defaultValue=""
                                value={department}
                                // onChange={(e) =>callselectrequest(e)}
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                {departmentlistdata.map((e, index) => (
                                  <option value={e.department}>
                                    {e.department}
                                  </option>
                                ))}
                              </select>
                              {/* <input
                            type="text"
                            name="department"
                            id="department"
                            value={department}
                            onChange={(e) =>
                                setDepartment(e.target.value)
                            }
                            placeholder="Enter Department"
                            required
                        /> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="subdepartment">
                                Sub Department
                              </label>
                            </div>
                            <div className="col-md-6">
                              <select
                                name="select"
                                id="selected"
                                onChange={(e) => handleChangesubdepmartment(e)}
                                defaultValue=""
                                value={sub_department}
                                // onChange={(e) =>callselectrequest(e)}
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                {subdepartmentlistdata.map((e, index) => (
                                  <option value={e.subdepartment}>
                                    {e.subdepartment}
                                  </option>
                                ))}
                              </select>
                              {/* <input
                           type="text"
                           name="subdepartment"
                           id="subdepartment"
                           value={sub_department}
                           onChange={(e) =>
                               setSub_department(e.target.value)
                           }
                           placeholder="Enter Sub Department"
                           required
                       /> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="subdepartment">
                                Contract Duration <br />
                                (In Months)
                              </label>
                            </div>
                            <div className="col-md-6">
                              <select
                                name="select"
                                id="selected"
                                onChange={(e) => handleChangeduration(e)}
                                defaultValue=""
                                // value={selectvendores}
                                // onChange={(e) =>callselectrequest(e)}
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                              </select>
                              {/* <input
                           type="text"
                           name="duration"
                           id="duration"
                           value={duration}
                           onChange={(e) =>
                               setDuration(e.target.value)
                           }
                           placeholder="Enter Duration"
                           required
                       /> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="birthday">
                                Contract End Date
                              </label>
                            </div>
                            <div className="col-md-6">
                              <input
                                type="date"
                                value={dot}
                                onChange={(e) => setDot(e.target.value)}
                                id="birthday"
                                name="birthday"
                              />
                            </div>
                          </div>{" "}
                        </div>
                        {/* <div className="col-md-4">                   
                       <div className="row">
                       <div className="col-md-6"><label htmlFor="reportingmanager">
                       Reporting Manager
                       </label></div>
                       <div className="col-md-6"> 
                       <input
                           type="text"
                           name="reportingmanager"
                           id="reportingmanager"
                           value={reporting_manager}
                           onChange={(e) =>
                               callmanagerfn(e.target.value)
                           }
                           placeholder="Enter Sub Department"
                           required
                       /> 
                       {isselected?<select
                       name="select"
                       id="selected"
                       onChange={e => handlechangerename(e)} 
                       defaultValue=""
                       // value={selectvendores}
                       // onChange={(e) =>callselectrequest(e)}
                   >
                        <option value=""  disabled >
                         Select
                       </option>
                        {rmlistdata.map((e, index) => (
                            <option value={e.employee_name} >{e.employee_name}</option>
                        ))}
                      
                                             
                       </select>:""}  
                       
                         
                           </div>
                       </div>
                       </div>  */}
                        {/* <div className="col-md-4">                   
                       <div className="row">
                       <div className="col-md-6"><label htmlFor="Managerid">
                       Manager Employee ID
                       </label></div>
                       <div className="col-md-6"> <input
                           type="text"
                           name="Managerempid"
                           id="managerid"
                           value={rmempid}
                           disabled
                           /></div>
                       </div>
                       </div> */}
                      </div>
                      <div className="row spacing">
                        {/* <div className="col-md-4">                   
                       <div className="row">
                       <div className="col-md-6"><label htmlFor="reportingmanager">
                       Billing Rate
                       </label></div>
                       <div className="col-md-6"> 
                       <input
                           type="text"
                           name="reportingmanager"
                           id="reportingmanager"
                           value={billingrate}
                           onChange={(e) =>
                               setBillingrate(e.target.value)
                           }
                           placeholder="Enter Billing"
                           required
                       /> 
                        
                       
                          
                           </div>
                       </div>
                       </div>  */}
                      </div>
                      <div className="row spacing">
                        <div className="col-md-12">
                          <div className="col-md-6">
                            <label htmlFor="discripfile">
                              Job Discription :{" "}
                              <img
                                onClick={(e) => addjobdec()}
                                className=""
                                style={{ width: "5%", cursor: "pointer" }}
                                src={uploadimg}
                                title="Upload"
                              />{" "}
                              <input
                                type="file"
                                id="discripfile"
                                style={{ display: "none" }}
                                onChange={(event) =>
                                  filechangedesfn(
                                    event.target.files[0] || null,
                                    "discripfile"
                                  )
                                }
                                accept="application/pdf"
                                data-original-title="upload photos"
                              ></input>
                            </label>
                          </div>
                          <textarea
                            id="faultreport"
                            name="faultreport"
                            value={jobdiscription}
                            onChange={(e) => setJobdiscription(e.target.value)}
                            placeholder="Write your message"
                            rows="4"
                            required
                          ></textarea>
                        </div>
                        <div className="col-md-4">
                          {/* <div className="row">
                        <div className="col-md-6"><label htmlFor="lastname">Contractor Name </label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="Contractorname"
                            id="Contractorname"
                            value={contractor_name}
                            onChange={(e) =>
                                setContractor_name(e.target.value)
                            }
                            placeholder="Enter Contractor Name"
                            required
                        /></div>
                        </div> */}
                        </div>
                        <div className="col-md-4">
                          {/* <div className="row">
                        <div className="col-md-6"><label htmlFor="vendorcode">
                        Vendor Code
                        </label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="vendorcode"
                            id="vendorcode"
                            value={vendor_code}
                            onChange={(e) =>
                                setVendor_code(e.target.value)
                            }
                            placeholder="Enter Vendor Code"
                            
                        /></div>
                        </div> */}
                        </div>
                      </div>

                      {isedited ? (
                        <>
                          <div className="row spacing">
                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="reportingmanager">
                                    Reporting Manager
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    name="reportingmanager"
                                    id="reportingmanager"
                                    value={reporting_manager}
                                    onChange={(e) =>
                                      callmanagerfn(e.target.value)
                                    }
                                    placeholder="Enter Sub Department"
                                    required
                                  />
                                  {isselected ? (
                                    <select
                                      name="select"
                                      id="selected"
                                      onChange={(e) => handlechangerename(e)}
                                      defaultValue=""
                                      value={reporting_manager}
                                      // onChange={(e) =>callselectrequest(e)}
                                    >
                                      <option value="">Select</option>
                                      {rmlistdata.map((e, index) => (
                                        <option value={e.employee_name}>
                                          {e.employee_name}
                                        </option>
                                      ))}
                                    </select>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="Managerid">
                                    Manager Employee ID
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <input
                                    type="text"
                                    name="Managerempid"
                                    id="managerid"
                                    value={rmempid}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="employeename">
                                    Cost Center
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    name="costcenter"
                                    id="costsenter"
                                    value={costcenter}
                                    onChange={(e) =>
                                      setCostcenter(e.target.value)
                                    }
                                    placeholder="Enter Cost Center"
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row spacing">
                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="billrate">
                                    Approved Bill rate
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    name="billrate"
                                    id="billrate"
                                    value={billingrate}
                                    onChange={(e) =>
                                      setBillingrate(e.target.value)
                                    }
                                    placeholder="Enter Billing rate"
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="transport">
                                    Transportation Support
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  {" "}
                                  <select
                                    name="select"
                                    id="selected"
                                    onChange={(e) => transportfn(e)}
                                    defaultValue={transportreq}
                                    // value={selectvendores}
                                    // onChange={(e) =>callselectrequest(e)}
                                  >
                                    <option value="" disabled>
                                      Select
                                    </option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="employeename">
                                    Meal Card Eligibility
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <select
                                    name="select"
                                    id="selected"
                                    onChange={(e) => couponfn(e)}
                                    defaultValue={couponreq}
                                    // value={selectvendores}
                                    // onChange={(e) =>callselectrequest(e)}
                                  >
                                    <option value="" disabled>
                                      Select
                                    </option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row spacing">
                            <div className="col-md-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <label htmlFor="billrate">
                                    System Asset Allocation
                                  </label>
                                </div>
                                <div className="col-md-6">
                                  <select
                                    name="select"
                                    id="selected"
                                    onChange={(e) => systemfn(e)}
                                    defaultValue={systemreq}
                                    // value={selectvendores}
                                    // onChange={(e) =>callselectrequest(e)}
                                  >
                                    <option value="" disabled>
                                      Select
                                    </option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            {systemreq === "Yes" ? (
                              <div className="col-md-4">
                                <div className="row">
                                  <div className="col-md-6">
                                    <label htmlFor="transport">
                                      Asset Type
                                    </label>
                                  </div>
                                  <div className="col-md-6">
                                    {" "}
                                    <select
                                      name="select"
                                      id="selected"
                                      onChange={(e) => assettyprfn(e)}
                                      defaultValue={assetreq}
                                      // value={selectvendores}
                                      // onChange={(e) =>callselectrequest(e)}
                                    >
                                      <option value="" disabled>
                                        Select
                                      </option>
                                      <option value="Laptop">Laptop</option>
                                      <option value="Desktop">Desktop</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {systemreq === "Yes" ? (
                              <div className="col-md-4">
                                <div className="row">
                                  <div className="col-md-6">
                                    <label htmlFor="employeename">
                                      SAP Access req
                                    </label>
                                  </div>
                                  <div className="col-md-6">
                                    <select
                                      name="select"
                                      id="selected"
                                      onChange={(e) => sapfn(e)}
                                      defaultValue={sapreq}
                                      // value={selectvendores}
                                      // onChange={(e) =>callselectrequest(e)}
                                    >
                                      <option value="" disabled>
                                        Select
                                      </option>
                                      <option value="Yes">Yes</option>
                                      <option value="No">No</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}{" "}
                            {sapreq == "Yes" ? (
                              <div className="col-md-4">
                                <div className="row">
                                  <div className="col-md-6">
                                    <label htmlFor="employeename">SAP ID</label>
                                  </div>
                                  <div className="col-md-6">
                                    <input
                                      type="text"
                                      name="sapid"
                                      id="sapid"
                                      value={sapid}
                                      onChange={(e) => setSapid(e.target.value)}
                                      placeholder="Enter SAP ID"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="upload-docs">
                            <h4>Uploaded Documents</h4>
                          </div>
                          <ul>
                            <li
                              className="list-design downloadlink"
                              onClick={() => calladharcard()}
                            >
                              Aadhar Card
                            </li>

                            {openpdfadhara === true ? (
                              <div id="myModal" className="modal-one-docs">
                                <img
                                  style={{
                                    width: "2%",
                                    cursor: "pointer",
                                    position: "absolute",
                                    marginLeft: "39%",
                                    marginTop: "1%",
                                  }}
                                  onClick={(e) => downloadfiles("Aadhar")}
                                  className=""
                                  src={downloadimg}
                                  title="download"
                                />
                                <div className="closebar">
                                  {" "}
                                  <span
                                    className="close-one-docs"
                                    onClick={() => callclose()}
                                  >
                                    &times;
                                  </span>
                                </div>
                                <div className="modal-content-one-docs">
                                  <iframe
                                    src={viewpdfdcsaadnar}
                                    width="100%"
                                    height="500px"
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {/* {openpdf===true?
                                <PDFViewer
                                document={{
                                    base64: viewpdfdcs,
                                    
                                }}
                              
                            />
                            //     <div
                            //     style={{
                            //         border: '1px solid rgba(0, 0, 0, 0.3)',
                            //         height: '750px',
                            //     }}
                            // >
                            //     <Viewer fileUrl={viewpdfdcs} />
                            // </div>
                            :''} */}
                            {/* {openpdf===true?
                             <iframe src={viewpdfdcs} width="100%" height="500px" />   
                            :''} */}
                            {/* <AllPagesPDFViewer pdf={samplePDF} /> */}
                            <li
                              className="list-design downloadlink"
                              onClick={() => callndacard()}
                            >
                              NDA
                            </li>
                            {openpdfnda === true ? (
                              <div id="myModal" className="modal-one-docs">
                                <img
                                  style={{
                                    width: "2%",
                                    cursor: "pointer",
                                    position: "absolute",
                                    marginLeft: "39%",
                                    marginTop: "1%",
                                  }}
                                  onClick={(e) => downloadfiles("NDA")}
                                  className=""
                                  src={downloadimg}
                                  title="download"
                                />
                                <div className="closebar">
                                  {" "}
                                  <span
                                    className="close-one-docs"
                                    onClick={() => callclose()}
                                  >
                                    &times;
                                  </span>
                                </div>
                                <div className="modal-content-one-docs">
                                  <iframe
                                    src={viewpdfdcsnda}
                                    width="100%"
                                    height="500px"
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            <li
                              className="list-design downloadlink"
                              onClick={() => calloffercard()}
                            >
                              Offer Letter
                            </li>
                            {openpdfoffer === true ? (
                              <div id="myModal" className="modal-one-docs">
                                <img
                                  style={{
                                    width: "2%",
                                    cursor: "pointer",
                                    position: "absolute",
                                    marginLeft: "39%",
                                    marginTop: "1%",
                                  }}
                                  onClick={(e) => downloadfiles("Offer Letter")}
                                  className=""
                                  src={downloadimg}
                                  title="download"
                                />
                                <div className="closebar">
                                  {" "}
                                  <span
                                    className="close-one-docs"
                                    onClick={() => callclose()}
                                  >
                                    &times;
                                  </span>
                                </div>
                                <div className="modal-content-one-docs">
                                  <iframe
                                    src={viewpdfdcsoffer}
                                    width="100%"
                                    height="500px"
                                  />
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </ul>
                          <div className="row">
                           
                            <input
                              type="radio"
                              name="verify"
                              value="verified"
                              id="verified"
                              checked={isverfiednew === "verified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Verified
                            <input
                              type="radio"
                              name="verify"
                              value="notverified"
                              id="notverified"
                              checked={isverfiednew === "notverified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Not Verified
                          </div>
                          <div className="row spacing">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <label htmlFor="lastname">Remarks</label>
                              </div>
                              <textarea
                                id="faultreport"
                                name="faultreport"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Write your message"
                                rows="4"
                                required
                              ></textarea>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <div className="row">
                        <Button
                          variant="primary"
                          className="btns bts-clear"
                          type="reset"
                          value="reset"
                          onClick={() => handleReset()}
                        >
                          Clear
                        </Button>
                        <Button
                          variant="primary"
                          className="btns bts-submit"
                          type="submit"
                          value="Submit"
                          onClick={(e) => handleSubmit(e)}
                        >
                          Submit
                        </Button>
                      </div>
                    </>
                  ) : isselectrenew ? (
                    <div className="col-md-4">
                      <div className="row vendor_code">
                        <div className="col-md-5">
                          <label htmlFor="renewemp">Switch Code</label>
                        </div>
                        <div className="col-md-7">
                          <input
                            type="text"
                            name="renewemp"
                            id="renewemp"
                            value={renewcode}
                            onChange={(e) => callrenewfn(e.target.value)}
                            placeholder="Enter Switch Code"
                            required
                          />
                          {isselectedcode ? (
                            <select
                              name="select"
                              id="selected"
                              onChange={(e) => handlechangecode(e)}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select
                              </option>
                              {switchcodelist.map((e, index) => (
                                <option value={e.switch_code}>
                                  {e.switch_code} ({e.employee_name})
                                </option>
                              ))}
                            </select>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </form>
              </fieldset>
            ) : isthirdtab ? (
              <div>
                <fieldset>
                  <div className="row spacing">
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="agreementID">MyContract ID</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="agreement"
                            id="agreementid"
                            onChange={(e) => callvendornamefn(e)}
                            value={agreementid}
                            placeholder="Enter MyContract ID"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="vendorname">Vendor Name</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="vendorname"
                            id="vendorname"
                            disabled
                            value={vendorname}
                            onChange={(e) => setVendorname(e.target.value)}
                            placeholder="Enter Vendor Name"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="vendorcodename">Vendor Code</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="vendorcodename"
                            id="vendorcodename"
                            value={vendorcodedata}
                            onChange={(e) => setVendorcodedata(e.target.value)}
                            placeholder="Enter Vendor Code"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row spacing">
                    {/* <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label htmlFor="birthday">DOJ</label></div>
                        <div className="col-md-6">
                            <input type="date"  min={mindateset} value={doj} onChange={(e) =>setDoj(e.target.value)} id="birthday" name="birthday"/>
                            </div></div> </div>     */}
                    {/* <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label htmlFor="vendorcontractorname">
                        Contractor Name
                        </label></div>
                        <div className="col-md-6"><input
                            type="text"
                            name="vendorcontractorname"
                            id="vendorcontractorname"
                            value={vendorcontractornamedata}
                            onChange={(e) =>
                                setVendorcontractornamedata(e.target.value)
                            }
                            placeholder="Enter Contractor Name"
                            required
                        /></div>
                        </div>
                        </div> */}
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="subdepartment">Business Type</label>
                        </div>
                        <div className="col-md-6">
                          <select
                            name="select"
                            id="selected"
                            onChange={(e) => handleChangebusinesstype(e)}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="Individual">Individual</option>
                            <option value="Partnership">Partnership</option>
                            <option value="Private Limited">
                              Private Limited
                            </option>
                            <option value="Public Limited">
                              Public Limited
                            </option>
                            <option value="LLP">LLP</option>
                            <option value="Sole Proprietorship">
                              Sole Proprietorship
                            </option>
                            {/* <option value="Proprietorship" >Proprietorship</option> */}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="employeename">
                            Business Email ID
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={vnemailid}
                            onChange={(e) => setVnemailid(e.target.value)}
                            placeholder="Enter Email ID"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="natureofengement">
                            Nature of Engagement
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="natureofenganement"
                            id="noengagement"
                            value={natureofeng}
                            onChange={(e) => setNatureofeng(e.target.value)}
                            placeholder="Nature of Engagement"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="birthday">Contract Start Date</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="date"
                            disabled
                            value={csd}
                            onChange={(e) => setCsd(e.target.value)}
                            id="csd"
                            name="csd"
                          />
                        </div>
                      </div>{" "}
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="birthday">Contract End Date</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="date"
                            disabled
                            value={ced}
                            onChange={(e) => setCed(e.target.value)}
                            id="ced"
                            name="ced"
                          />
                        </div>
                      </div>{" "}
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="employeesecondname">
                            Business License Number
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            name="businesslicense"
                            id="businesslicense"
                            value={businesslicense}
                            onChange={(e) => setBusinesslicense(e.target.value)}
                            placeholder="Business License Number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row spacing">
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="birthday">
                            Business Registration Date
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="date"
                            value={brd}
                            onChange={(e) => setBrd(e.target.value)}
                            id="brd"
                            name="brd"
                          />
                        </div>
                      </div>{" "}
                    </div>

                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Registered Address</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={companyaddress}
                            onChange={(e) => setCompanyaddress(e.target.value)}
                            placeholder="Enter Address"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Operating Address</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            // disabled={operatingaddress===''?false:true}
                            value={operatingaddress}
                            onChange={(e) =>
                              setOperatingaddress(e.target.value)
                            }
                            placeholder="Enter Address"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row spacing"></div>
                  <div className="row spacing">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-2">
                          <label htmlFor="businessdesp">
                            Business Description{" "}
                          </label>
                        </div>
                        <div
                          className="col-md-10"
                          style={{ marginLeft: "-1%" }}
                        >
                          <textarea
                            id="faultreport"
                            name="faultreport"
                            value={businesdesp}
                            onChange={(e) => setBusinesdesp(e.target.value)}
                            placeholder="Write your message"
                            rows="4"
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row spacing"></div>
                  <div className="upload-docs">
                    <h4>Contact Information</h4>
                  </div>

                  <div className="row spacing">
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Primary Contact Name</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="primarycontactnumber"
                            id="primary"
                            value={primarycontactname}
                            onChange={(e) => checkmobileprimary(e.target.value)}
                            placeholder="Enter Contact Name"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Primary Email ID</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="emailid_primart"
                            id="emailid_primary"
                            value={emailid_primary}
                            onChange={(e) => setEmailid_primary(e.target.value)}
                            placeholder="Enter Email ID"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Primary Phone No.</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            name="primary_mobilenumber"
                            id="primary_mobilenumber"
                            value={mobileno_primary}
                            onChange={(e) => checkmobileno(e.target.value)}
                            placeholder="Enter Phone Number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">
                            Secondary Contact Name{" "}
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="alt_contact_name"
                            id="alt_contact_name"
                            value={alt_contact_name}
                            onChange={(e) =>
                              setAlt_contact_name(e.target.value)
                            }
                            placeholder="Enter Alternate Contact Name"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Secondary Email ID</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            name="alt_email_id"
                            id="alt_email_id"
                            value={alt_email_id}
                            onChange={(e) => setAlt_email_id(e.target.value)}
                            placeholder="Enter Secondary Email ID"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label htmlFor="lastname">Secondary Phone No. </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            name="alt_contact_phone"
                            id="alt_contact_phone"
                            value={alt_contact_phone}
                            onChange={(e) => checkmobilealt(e.target.value)}
                            placeholder="Enter Secondary Phone No."
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="upload-docs">
                    <h4>Compliance & Legal Documentation</h4>
                  </div>
                  <div className="row spacing">
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label for="myfile">PAN card</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfilevender_pan"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangepanfn(
                                event.target.files[0] || null,
                                "myfilevender_pan"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <label for="myfile">
                            GST Registration Certificate :
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_gst"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangegstfn(
                                event.target.files[0] || null,
                                "myfile_gst"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <label for="myfile">
                            Professional Tax Registration Certificate:
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_proftax"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangeproftaxfn(
                                event.target.files[0] || null,
                                "myfile_proftax"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    {individualtype === true ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            {" "}
                            <label for="myfile">Local Trade License:</label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile_locallicense"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangelocallicensefn(
                                  event.target.files[0] || null,
                                  "myfile_locallicense"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {individualtype || parnershiptype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            {" "}
                            <label for="myfile">
                              Commercial Tax Registration Certificate:
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile_commtax"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangecommstaxregfn(
                                  event.target.files[0] || null,
                                  "myfile_commtax"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <label for="myfile">
                            ESI Registration Certificate:
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_esi"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangeesifn(
                                event.target.files[0] || null,
                                "myfile_esi"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          {" "}
                          <label for="myfile">
                            Contract Labour Registration:
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_contlabourreg"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangecontlabreg(
                                event.target.files[0] || null,
                                "myfile_contlabourreg"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    {parnershiptype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            {" "}
                            <label for="myfile">
                              Partnership Registration Certificate:
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile_partnershipcerti"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangepartnership(
                                  event.target.files[0] || null,
                                  "myfile_partnershipcerti"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {parnershiptype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            {" "}
                            <label for="myfile">Partnership Deed:</label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile_deed"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangedeed(
                                  event.target.files[0] || null,
                                  "myfile_deed"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {labellptype || privateltype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            {" "}
                            <label for="myfile">
                              Certificate of Incorporation:
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfiles-incorporate"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangefn(
                                  event.target.files[0] || null,
                                  "myfiles-incorporate"
                                )
                              }
                              name="myfiles"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="myfile">Partnership Registration Deed </label></div>
                        <div className="col-md-6">
                        <input type="file" id="myfile-regis" accept="application/pdf" onChange={(event) => filechangeregisfn(event.target.files[0] || null,"myfile-regis")} name="myfile" />
                            </div>
                        </div>
                        </div> */}
                    {parnershiptype === true ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <label for="myfile">
                              Amended Partnership Deed(s){" "}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile-amended"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangeamended(
                                  event.target.files[0] || null,
                                  "myfile-amended"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {labellptype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <label for="myfile">LLP Agreement</label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile-llpagree"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangellp(
                                  event.target.files[0] || null,
                                  "myfile-llpagree"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {labellptype || privateltype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <label for="myfile">Copy of POA</label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile-POA"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangepoa(
                                  event.target.files[0] || null,
                                  "myfile-POA"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {privateltype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <label for="myfile">
                              Memorandum of Association
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile-moa"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangemoa(
                                  event.target.files[0] || null,
                                  "myfile-moa"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {privateltype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <label for="myfile">Articles of Association</label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile-association"
                              accept="application/pdf"
                              onChange={(event) =>
                                filechangeassociation(
                                  event.target.files[0] || null,
                                  "myfile-association"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {privateltype ? (
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <label for="myfile">
                              Certificate of Commencement of Business
                            </label>
                          </div>
                          <div className="col-md-6">
                            <input
                              type="file"
                              id="myfile-commenceofbusiness"
                              accept="application/pdf"
                              onChange={(event) =>
                                fccertificommbusiness(
                                  event.target.files[0] || null,
                                  "myfile-commenceofbusiness"
                                )
                              }
                              name="myfile"
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="upload-docs">
                    <h4>Signed Contract</h4>
                  </div>
                  <div className="row spacing">
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label for="myfile">Contract proposal form</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_contractproposal"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangendproposalfn(
                                event.target.files[0] || null,
                                "myfile_contractproposal"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label for="myfile">
                            Non-Disclosure Agreement (NDA) Signed
                          </label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_nrd_vendor"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangendasignedfn(
                                event.target.files[0] || null,
                                "myfile_nrd_vendor"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-6">
                          <label for="myfile">Service Provider Agreement</label>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="file"
                            id="myfile_agreement"
                            accept="application/pdf"
                            onChange={(event) =>
                              filechangevendoraggfn(
                                event.target.files[0] || null,
                                "myfile_agreement"
                              )
                            }
                            name="myfile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4"></div>
                  </div>
                  <div className="row">
                    <Button
                      variant="primary"
                      className="btns bts-clear"
                      type="reset"
                      value="reset"
                      onClick={() => handleReset()}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="primary"
                      className="btns bts-submit"
                      type="submit"
                      value="Submit"
                      onClick={() => handleSubmit_vender()}
                    >
                      Submit
                    </Button>
                  </div>
                </fieldset>
              </div>
            ) : isfourthtab ? (
              <div className="table-boxs">
                <div className="row">
                  <div className="col-md-1">
                    <label htmlFor="switchcode">Search</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="switchcode"
                      id="switchcode"
                      value={searchdata}
                      onChange={(e) => searchfunctionvendor(e.target.value)}
                      placeholder="Search"
                      required
                    />
                  </div>
                </div>
                <table className="table-full mt-3">
                  <thead className="header-asset">
                    <tr>
                      <th>Sl.No</th>
                      <th>Vendor Name</th>
                      <th>Vendor Code</th>
                      <th>Business Type</th>
                      {/* <th>DOJ</th> */}
                      <th>Business Email ID</th>
                      <th>Nature of Engagement</th>
                      {/* <th>Sub Department</th> */}
                      <th>Contract Start Date</th>
                      <th>Contract End Date</th>
                      {/* <th>Manager Employee ID</th> */}
                      {/* <th>Contractor Name</th>
                  <th>Vendor Code</th> */}
                      <th>Business License No.</th>
                      <th>Business Registration Date</th>
                      <th>Registered Address</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {vendorlistdata.length
                      ? vendorlistdata.map((val, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{val.vendorname}</td>
                              <td>{val.vendorcode}</td>
                              <td>{val.businesstype}</td>
                              {/* <td>{val.doj}</td>  */}
                              <td>{val.vnemailid}</td>
                              <td>{val.natureofeng}</td>
                              {/* <td>{val.sub_department}</td>  */}
                              <td>{val.csd}</td>
                              {/* <td>{val.manager_id}</td>  */}
                              {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  */}
                              <td>{val.ced}</td>
                              <td>{val.businesslicense} </td>
                              <td>{val.brd}</td>
                              <td>{val.companyaddress}</td>

                              {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}

                              {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            ) : isfifth ? (
              <div className="table-boxs">
                {/* <div className="row">
                  <div className="col-md-1">
                    <label htmlFor="switchcode">Search</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="switchcode"
                      id="switchcode"
                      value={searchdata}
                      onChange={(e) => searchfunctionvendor(e.target.value)}
                      placeholder="Search"
                      required
                    />
                  </div>
                </div> */}
                <table className="table-full mt-3">
                  <thead className="header-asset">
                    <tr>
                      <th>Sl.No</th>
                      <th>Switch Code</th>
                      <th>Employee Code</th>
                      <th>Employee Name</th>
                      {/* <th>DOJ</th> */}
                      <th>Work Location</th>
                      <th>Department</th>
                      {/* <th>Sub Department</th> */}
                      <th>Reporting Manager</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {seperationlist.length
                      ? seperationlist.map((val, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{val.switch_code}</td>
                              <td>{val.employee_code}</td>
                              <td>{val.employee_name}</td>
                              {/* <td>{val.doj}</td>  */}
                              <td>{val.location}</td>
                              <td>{val.department}</td>
                              {/* <td>{val.sub_department}</td>  */}
                              <td>{val.reporting_manager}</td>
                               <td>{val.exit_request}</td>
                              {/* <td>{val.manager_id}</td>  */}
                              {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  */}
                             
                              <td style={{ width: "10%" }}><img
                                  style={{ width: "20%", cursor: "pointer" }}
                                  onClick={(e) =>separatefn(val)}
                                  className=""
                                  src={edit}
                                  title="Edit"
                                /></td>

                              {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}

                              {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            ):issixth ? (
              <div className="table-boxs">
                 <table className="table-full mt-3">
                  <thead className="header-asset">
                    <tr>
                      <th>Sl.No</th>
                      <th>Switch Code</th>
                      <th>Employee Name</th>
                      {/* <th>DOJ</th> */}
                      <th>Work Location</th>
                      <th>Department</th>
                      {/* <th>Sub Department</th> */}
                      <th>Reporting Manager</th>
                      <th>Seperation Request</th>
                      <th>Updated Date</th>
                      <th>IT </th>
                      <th>Admin</th>
                      <th>RM </th>
                    </tr>
                  </thead>
                  <tbody>
                    {seperationlistall.length
                      ? seperationlistall.map((val, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{val.switch_code}</td>
                              <td>{val.employee_name}</td>
                              {/* <td>{val.employee_name}</td> */}
                              {/* <td>{val.doj}</td>  */}
                              <td>{val.location}</td>
                              <td>{val.department}</td>
                              {/* <td>{val.sub_department}</td>  */}
                              <td>{val.reporting_manager}</td>
                              <td>{val.exit_request}</td>     
                              <td>{formatDate(val.updated_timestamp)}</td>                            
                               <td>{val.it_noc_status}</td>
                               <td>{val.admin_noc_status}</td>
                               <td>{val.rm_noc_status}</td>
                               
                              {/* <td>{val.manager_id}</td>  */}
                              {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  */}
                             
                              {/* <td style={{ width: "10%" }}><img
                                  style={{ width: "20%", cursor: "pointer" }}
                                  onClick={(e) =>separatefn(val)}
                                  className=""
                                  src={edit}
                                  title="Edit"
                                /></td> */}

                              {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}

                              {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            ):
            (
              <div className="table-boxs">
                <div className="row">
                  <div className="col-md-1">
                    <label htmlFor="switchcode">Search</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="switchcode"
                      id="switchcode"
                      value={searchdata}
                      onChange={(e) => searchfunction(e.target.value)}
                      placeholder="Search"
                      required
                    />
                  </div>
                  <div className="col-md-1">
                    <Button variant="info" onClick={() => generatereport()}>
                      <img
                        style={{
                          width: "80%",
                          cursor: "pointer",
                          filter: "invert(1)",
                        }}
                        className=""
                        src={downloadimgbk}
                        title="download"
                      />
                    </Button>
                  </div>
                </div>
                <table className="table-full mt-3">
                  <thead className="header-asset">
                    <tr>
                      <th>Sl.No</th>
                      <th>Switch Code</th>
                      <th>Employee Code</th>
                      <th>Employee Name</th>
                      {/* <th>DOJ</th> */}
                      <th>Work Location</th>
                      <th>Department</th>
                      {/* <th>Sub Department</th> */}
                      <th>Reporting Manager</th>
                      {/* <th>Manager Employee ID</th> */}
                      {/* <th>Contractor Name</th>
                  <th>Vendor Code</th> */}
                      <th>Verified</th>
                      <th>Status</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendorlist.length
                      ? vendorlist.map((val, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{val.switch_code}</td>
                              <td>{val.employee_code}</td>
                              <td>{val.employee_name}</td>
                              {/* <td>{val.doj}</td>  */}
                              <td>{val.location}</td>
                              <td>{val.department}</td>
                              {/* <td>{val.sub_department}</td>  */}
                              <td>{val.reporting_manager}</td>
                              {/* <td>{val.manager_id}</td>  */}
                              {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  */}
                              <td>{val.verified}</td>
                              <td>{val.status} </td>
                              <td>{val.remarks}</td>
                              <td style={{ width: "15%" }}>
                                <img
                                  style={{ width: "31%", cursor: "pointer" }}
                                  onClick={(e) => mailsent(val)}
                                  className=""
                                  src={sentmail}
                                  title="Sent Mail"
                                />
                                <img
                                  style={{ width: "31%", cursor: "pointer" }}
                                  onClick={(e) => edituser(val)}
                                  className=""
                                  src={edit}
                                  title="Edit"
                                />
                                <img
                                  style={{ width: "31%", cursor: "pointer" }}
                                  onClick={(e) => removeuser(val)}
                                  className=""
                                  src={remove}
                                  title="Remove"
                                />
                              </td>

                              {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
